//import Ad from '../components/Ad'
import Card from 'react-bootstrap/Card'
import { OutboundLink } from 'react-ga'
import styles from '../styles/PleaseSupportUs.module.scss'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const PleaseSupportUs = ({ height, width }) => {
  const profile = useSelector((state) => state.firebase.profile)
  const [randomRoll, setRandomRoll] = useState(Math.random())

  // TODO move ad stuff to Leaderboard.js

  /*if (randomRoll >= 0.65) {
    return <Ad suffix={1} />
  } else if (randomRoll >= 0.35) {
    return <Ad suffix={2} />
  } */

  return (
    <Card className='shadow-sm'>
      <div
        className={styles.container}
        style={{
          height: height || 200,
          width: width || 'auto',
        }}
      >
        <OutboundLink
          eventLabel='https://patreon.com/edhrec'
          rel='noopener noreferrer'
          target='_blank'
          to='https://patreon.com/edhrec'
        >
          Please consider supporting us on Patreon to remove ads for only
          $2/month.
        </OutboundLink>
      </div>
    </Card>
  )
}

export default PleaseSupportUs
